export default __webpack_public_path__ + "static/media/IMG_5355.b726cddb.PNG";